import { Loader2 } from "lucide-react";
import {
  AlertDialog,
  AlertDialogAction,
  AlertDialogBody,
  AlertDialogCancel,
  AlertDialogContent,
  AlertDialogDescription,
  AlertDialogFooter,
  AlertDialogHeader,
  AlertDialogTitle,
} from "@/components/ui/alert-dialog";
import {
  BusyOverlay,
  PROVIDER_WAIT_HINT,
} from "@/components/common/BusyOverlay";

interface N8nVmDeleteDialogProps {
  open: boolean;
  resourceName: string;
  vmUuid?: string | null;
  isPending: boolean;
  onOpenChange: (open: boolean) => void;
  onConfirm: () => void;
}

/** Shared confirmation for direct VM deletion from resource details and the expired-VM table. */
export function N8nVmDeleteDialog({
  open,
  resourceName,
  vmUuid,
  isPending,
  onOpenChange,
  onConfirm,
}: N8nVmDeleteDialogProps) {
  return (
    <>
      <AlertDialog
        open={open}
        onOpenChange={(next) => {
          if (!isPending) onOpenChange(next);
        }}
      >
        <AlertDialogContent
          onEscapeKeyDown={(event) => {
            if (isPending) event.preventDefault();
          }}
        >
          <AlertDialogHeader>
            <AlertDialogTitle>
              Delete {resourceName} through n8n?
            </AlertDialogTitle>
          </AlertDialogHeader>
          <AlertDialogBody>
            <AlertDialogDescription>
              Delete the real VM and its data for UUID{" "}
              <span className="break-all font-mono">{vmUuid}</span>. WiCloud's
              resource record and billing will remain unchanged.
            </AlertDialogDescription>
          </AlertDialogBody>
          <AlertDialogFooter>
            <AlertDialogCancel disabled={isPending}>Cancel</AlertDialogCancel>
            <AlertDialogAction
              className="bg-destructive text-destructive-foreground hover:bg-destructive/90"
              disabled={isPending || !vmUuid}
              onClick={(event) => {
                event.preventDefault();
                if (!isPending && vmUuid) onConfirm();
              }}
            >
              {isPending && <Loader2 className="mr-2 h-4 w-4 animate-spin" />}
              {isPending ? "Deleting…" : "Delete VM"}
            </AlertDialogAction>
          </AlertDialogFooter>
        </AlertDialogContent>
      </AlertDialog>
      <BusyOverlay
        open={isPending}
        label="Requesting VM deletion…"
        hint={PROVIDER_WAIT_HINT}
      />
    </>
  );
}
